var map = {
	"./index.js": "IcnI",
	"./nav.js": "SOLU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HkK1";


//////////////////
// WEBPACK FOOTER
// ./src/store ^\.\/(?!-)[^.]+\.(js)$
// module id = HkK1
// module chunks = 12